import { ref, watch, type Ref } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import { checkPrefixConflicts } from '@/entities/Document';
import { useCustomToast } from '@/shared/lib';
import { PREFIX_ALREADY_IN_PROGRESS_MESSAGE } from '@/shared/config';

export function usePrefixConflictCheck(prefixes: Ref<string[]>) {
  const conflictingPrefixes = ref<string[]>([]);
  const isCheckingPrefixConflicts = ref(false);
  const toast = useCustomToast();

  const debouncedCheck = useDebounceFn(async (list: string[]) => {
    try {
      const result = await checkPrefixConflicts(list);
      const newConflicts = result.filter((prefix) => !conflictingPrefixes.value.includes(prefix));
      conflictingPrefixes.value = result;

      if (newConflicts.length > 0) {
        toast.showErrorToast(
          {
            title: 'Conflito de prefixo',
            message: PREFIX_ALREADY_IN_PROGRESS_MESSAGE,
            type: 'error',
          },
          { timeout: 6000 }
        );
      }
    } catch (error) {
      console.error('Erro ao verificar conflito de prefixo', error);
    } finally {
      isCheckingPrefixConflicts.value = false;
    }
  }, 300);

  watch(
    prefixes,
    (list) => {
      if (list.length === 0) {
        conflictingPrefixes.value = [];
        isCheckingPrefixConflicts.value = false;
        return;
      }
      isCheckingPrefixConflicts.value = true;
      debouncedCheck(list);
    },
    { immediate: true }
  );

  return {
    conflictingPrefixes,
    isCheckingPrefixConflicts,
  };
}
